
import TableList from "@components/templates/tablelist";
import { HttpGetAfSaleslist, HttpGetChangeStatus } from "@/service/aftersales/aftersales";
import { mapState, mapGetters } from "vuex";
import comIndex from './update'
import invalidModal from './invalidModal'
import compUpload from './upload.vue'
export default {
    mixins: [TableList],
    components: {
        comIndex, invalidModal,compUpload
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    quanbu: 0,
                }
            },
            exportData:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename:'',
            datetime:'',
            Plugins: {show: true},
            initData:'',
        };
    },
    // created(){
        // this.timehandle()
    // },
    methods: {
        // timehandle(){
        //     let GE_updatedAt = this.getDay(-7)
        //     let LE_updatedAt = this.getDay(0)
        //     this.initData = GE_updatedAt + ' ~ ' + LE_updatedAt
        // },
        // 封装时间函数
        // getDay(day){
        // 　　var today = new Date();
        // 　　var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
        // 　　today.setTime(targetday_milliseconds); //注意，这行是关键代码
        // 　　var tYear = today.getFullYear();
        // 　　var tMonth = today.getMonth();
        // 　　var tDate = today.getDate();
        // 　　tMonth = this.doHandleMonth(tMonth + 1);
        // 　　tDate = this.doHandleMonth(tDate);
        // 　　return tYear+"-"+tMonth+"-"+tDate;
        // },
        // doHandleMonth(month){
        // 　　var m = month;
        // 　　if(month.toString().length == 1){
        // 　　　　m = "0" + month;
        // 　　}
        // 　　return m;
        // },
        ajaxRequest: HttpGetAfSaleslist,
        // interceptRequest(params){
        //     const search=params.search,createdAt=(search.GE_updatedAt||"").split('~');
        //     search.GE_updatedAt=createdAt[0];
        //     search.LE_updatedAt=createdAt[1];
        //     return params;
        //     console.log(params)
        // },
        interceptRequest(params){
            if(params.search.quanbu == 0){
                params.search.all = null;
            }
            delete params.search.quanbu
            this.exportData = params
            return params;
        },
        // interceptResponse(data){
        //     this.totals = data.totalElements;
        // },
        // toolsRender(){ //自定义工具行
        //     return <conmSear class="color-error"></conmSear>
        // },
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'afterSaleUpdate',
                        params: { type: "add" },
                        // query: { id: params },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'afterSaleUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.operation_see',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "afterSaleUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;

                case "b2cquery":
                    var url=this.$router.resolve({
                        name: "b2cOrderupdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "invalid":
                    this.operate = {
                        component: 'invalidModal',
                        show: true,
                        value: true,
                        alert: "error",
                        title: this.$t('erp.channelbase.zuofei',{defaultValue:'作废'}),
                        width: 460,
                        params:{id:params,statusCode:4},
                        desc: this.$t('erp.aftersales.zuofeitip',{defaultValue:'注意：作废售后单不会同步取消自动生成的补发单，请取消补发单（B2C订单页面）后再作废售后单！'}),
                        descStyle: 'text-align: left;',
                        descClass: 'color-error',
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('erp.channelbase.zuofei',{defaultValue:'作废'}) + this.$t('global.common.reason',{defaultValue:'原因'}),
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpGetChangeStatus
                    };
                    break;
                case "archive":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: this.$t('erp.aftersales.archive',{defaultValue:'归档'}),
                        width: 460,
                        params:{id:params,statusCode:3},
                        ajaxRequest:HttpGetChangeStatus
                    };
                    break;
                case 'export':
                    if(this.total>2000){
                        this.$VMessage.error(this.$t('erp.b2c.alert_morethanother',{defaultValue:'导出数据不要超过'})+'2000');
                    }else{
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/orderSerivce/export',this.exportData,{
                            executor:'request',
                            download:true,
                        }).catch(err=>{
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        });
                    }
                    break;
                // 退货单的退货导出
                case 'exportReturn':
                    if(this.total>2000){
                        this.$Message.error(this.$t('erp.b2c.alert_morethanother',{defaultValue:'导出数据不要超过'})+'2000');
                    }else{
                        // this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/orderSerivce/exportReturn',this.formData,{
                        //     executor:'request',
                        //     download:true,
                        // }).catch(err=>{
                        //     this.$Message.error({
                        //         content: err.message,
                        //         duration: 30,
                        //         closable: true
                        //     });
                        // });
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +'/api/v2/orderSerivce/exportReturn',this.formData, 'download')
                    }
                    break;
                 case 'upload':
                    {
                        this.operate = {
                            show: true,
                            title: "导入数据",
                            width: 460,
                            showFooter: false,
                            component: 'compUpload',
                        };
                    }
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id, orderStatus } = row
            return [{
                label:this.$t('global.common.operation_see',{defaultValue:'查看'}),
                show:true,
                params:id,
                operate:'query'
            },{
                label:this.$t('global.common.operation_edit',{defaultValue:'编辑'}),
                show: orderStatus == 'ESTABLISH' || orderStatus == 'INPROCESS' || orderStatus == 'FINISHED',
                // params:id,
                // operate:'edit'
                to: {
                    name: 'afterSaleUpdate',
                    params: { type: 'edit'},
                    query: { id },
                },
            },{
                label:this.$t('erp.channelbase.zuofei',{defaultValue:'作废'}),
                show: orderStatus == 'ESTABLISH' || orderStatus == 'INPROCESS' || orderStatus == 'FINISHED',
                params:id,
                operate:'invalid'
            },
            {
                label:this.$t('erp.aftersales.archive',{defaultValue:'归档'}),
                show: orderStatus == 'FINISHED',
                params:id,
                operate:'archive'
            }, ]
        },
    },
    computed: {
        // ...mapState('boss', ['accounts','products']),
        ...mapGetters('boss', ['otherWarehouses']),
        ...mapGetters('diction',['getNewProductList','getNewAccountList']),
        orderStatus(){
            return [
                {
                    value: 'establish',
                    label: this.$t('fbb.costmanage.created',{defaultValue:'已创建'}),
                    theme:'info',
                },
                {
                    value: 'submit',
                    label: this.$t('fbb.alloment.has_commit',{defaultValue:'已提交'}),
                    theme:'warning',
                },
                {
                    value: 'purchased',
                    label: this.$t('erp.aftersales.buypurchase',{defaultValue:'已购买'}),
                    theme:'success'
                },
                {
                    value: 'printed',
                    label: this.$t('erp.aftersales.printed',{defaultValue:'已打印'}),
                    theme: 'info'
                },
                {
                    value: 'close',
                    label: this.$t('global.common.canceled',{defaultValue:'已取消'}),
                    theme:'error',
                },
            ];
        },
        TabsData(){
            return [
                {
                    name: this.$t('global.common.all',{defaultValue:'全部'}),
                    // key:'all',
                    key: 'quanbu',
                    val: 0
                }, {
                    name: this.$t('erp.aftersales.refundorder',{defaultValue:'退款单'}),
                    key:'NE_refundId',
                    val: "0"
                }, {
                    name: this.$t('erp.aftersales.goodsorder',{defaultValue:'退货单'}),
                    key:'NE_returnId',
                    val: "0"
                }, {
                    name: this.$t('erp.aftersales.replaceorder',{defaultValue:'补发单'}),
                    key: "NE_replacementId",
                    val:"0"
                }
            ]
        },
        ToolsData(){
            return [
                {
                    name: this.$t('global.common.add',{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                    hidden:!(this.formData.search['all']==null)
                },
                {
                    name: this.$t('global.common.condition_export',{defaultValue:'查询条件导出'}),
                    // hidden:!(this.formData.search['all']==null),
                    show: !this.formData.search.NE_returnId,
                    operate: "export",
                    // theme: "primary",
                },
                {
                    name: this.$t('boss.aftersales.export_return_order',{defaultValue:'退货单导出'}),
                    // hidden:!(this.formData.search['all']==null),
                    show: this.formData.search.NE_returnId == 0 && this.handleAuth('erp.orderService.export'),
                    operate: "exportReturn",
                },
                {
                    name: "退货单导入",
                    operate: "upload",
                    theme: "success",
                    show:true
                }
            ]
        },
        SearchsData() {
            let dropStyle="width:auto;min-width:186px;";
            return  [
                {
                    label: this.$t('erp.aftersales.orderServiceNo',{defaultValue:'售后单号'}),
                    tag: 'vInput',
                    key: 'EQ_orderServiceNo',
                    show:true,
                },
                {
                    label: this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
                    tag: 'vInput',
                    key: 'CN_orderNo',
                    show:true,
                },
                {
                    label: this.$t('global.common.status',{defaultValue:'状态'}),
                    tag: 'vSelect',
                    key: 'EQ_orderStatus',
                    hidden:!(this.formData.search['all']==null),
                    show:true,
                    options:[
                        {
                            value: 'ESTABLISH',
                            label: this.$t('fbb.costmanage.created',{defaultValue:'已创建'})
                        },
                        {
                            value: 'INPROCESS',
                            label: this.$t('bi.work.task_status_processing',{defaultValue:'处理中'})
                        },
                        {
                            value: 'FINISHED',
                            label: this.$t('global.upload.complete',{defaultValue:'已完成'})
                        },
                        {
                            value: 'ARRANGED',
                            label: this.$t('global.upload.before_archive',{defaultValue:'已归档'})
                        },
                        {
                            value: 'NULLIFY',
                            label: this.$t('erp.aftersales.nullify',{defaultValue:'已作废'})
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                // 展示出来的搜索
                {
                    label: this.$t('erp.aftersales.refundStatus',{defaultValue:'退款状态'}),
                    tag: 'vSelect',
                    key: 'EQ_orderServiceRefundItemsEntity.refundStatus',
                    hidden:!(this.formData.search['NE_refundId']=='0'),
                    show:true,
                    options:[
                        {
                            value: 'NOREFUND',
                            label: this.$t('erp.aftersales.norefund',{defaultValue:'未退款'})
                        },
                        {
                            value: 'REFUNDED',
                            label: this.$t('erp.aftersales.refunded',{defaultValue:'已退款'})
                        },
                        {
                            value: 'NULLIFY',
                            label: this.$t('erp.aftersales.nullify',{defaultValue:'已作废'})
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.aftersales.goodsStatus',{defaultValue:'退货状态'}),
                    tag: 'vSelect',
                    key: 'EQ_orderServiceReturnItemsEntity.returnStatus',
                    hidden:!(this.formData.search['NE_returnId']=='0'),
                    show:true,
                    options:[
                        {
                            value: 'NORETURN',
                            label: this.$t('erp.aftersales.noreturn',{defaultValue:'未退货'})
                        },
                        {
                            value: 'RETURNED',
                            label: this.$t('erp.aftersales.returned',{defaultValue:'已退货'})
                        },
                        {
                            value: 'RETURNING',
                            label: this.$t('erp.aftersales.returning',{defaultValue:'已接收'})
                        },
                        {
                            value: 'NULLIFY',
                            label: this.$t('erp.aftersales.nullify',{defaultValue:'已作废'})
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.aftersales.replaceorder',{defaultValue:'补发单号'}),
                    tag: 'vInput',
                    key: 'EQ_orderServiceReplacementItemsEntity.replacementOrderNo',
                    hidden:!(this.formData.search['NE_replacementId']=='0'),
                    show:true,
                },

                // 隐藏起来的搜索
                {
                    label: this.$t('erp.b2c.channel_account',{defaultValue:'渠道账号'}),
                    tag: 'vSelect',
                    key: 'EQ_sourceChannel',
                    options:this.getNewAccountList,
                    style: "width:180px",
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.aftersales.refundStatus',{defaultValue:'退款状态'}),
                    tag: 'vSelect',
                    key: 'EQ_orderServiceRefundItemsEntity.refundStatus',
                    hidden:!(this.formData.search['all']==null),
                    options:[
                        {
                            value: 'NOREFUND',
                            label: this.$t('erp.aftersales.norefund',{defaultValue:'未退款'})
                        },
                        {
                            value: 'REFUNDED',
                            label: this.$t('erp.aftersales.refunded',{defaultValue:'已退款'})
                        },
                        {
                            value: 'NULLIFY',
                            label: this.$t('erp.aftersales.nullify',{defaultValue:'已作废'})
                        },
                    ],
                    style: "width:180px",
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.aftersales.replaceorder',{defaultValue:'补发单号'}),
                    tag: 'vInput',
                    key: 'EQ_orderServiceReplacementItemsEntity.replacementOrderNo',
                    hidden:!(this.formData.search['all']==null),
                    style: "width:180px",
                },
                {
                    label: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    style: "width:180px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: this.$t('erp.aftersales.refundAt',{defaultValue:'退款时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_orderServiceRefundItemsEntity.refundAt',
                    style: "width:180px",
                    hidden:!(this.formData.search['NE_refundId']=='0'),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: this.$t('erp.aftersales.returnAt',{defaultValue:'退货时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_orderServiceReturnItemsEntity.returnAt',
                    style: "width:180px",
                    hidden:!(this.formData.search['NE_returnId']=='0'),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: this.$t('erp.aftersales.replacementAt',{defaultValue:'补发时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_orderServiceReplacementItemsEntity.replacementAt',
                    style: "width:180px",
                    hidden:!(this.formData.search['NE_replacementId']=='0'),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options:this.getNewProductList,
                    style: "width:180px",
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.aftersales.trackingNo',{defaultValue:'退货tracking'}),
                    tag: 'vInput',
                    key: 'EQ_orderServiceItemsEntityList.trackingNo',
                    hidden:!(this.formData.search['NE_returnId']=='0'||this.formData.search['all']==null),
                    style: "width:180px",
                },
                // 隐藏起来的搜索
                {
                    label: this.$t('erp.aftersales.goodsStatus',{defaultValue:'退货状态'}),
                    tag: 'vSelect',
                    key: 'EQ_orderServiceReturnItemsEntity.returnStatus',
                    hidden:!(this.formData.search['all']==null),
                    options:[
                        {
                            value: 'NORETURN',
                            label: this.$t('erp.aftersales.noreturn',{defaultValue:'未退货'}),
                        },
                        {
                            value: 'RETURNED',
                            label: this.$t('erp.aftersales.returned',{defaultValue:'已退货'})
                        },
                        {
                            value: 'RETURNING',
                            label: this.$t('erp.aftersales.returning',{defaultValue:'已接收'})
                        },
                        {
                            value: 'NULLIFY',
                            label: this.$t('erp.aftersales.nullify',{defaultValue:'已作废'})
                        },
                    ],
                    style: "width:180px",
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.aftersales.replacementStatus',{defaultValue:'补发状态'}),
                    tag: 'vSelect',
                    key: 'EQ_orderServiceReplacementItemsEntity.replacementStatus',
                    hidden:!(this.formData.search['all']==null || this.formData.search['NE_replacementId']=='0'),
                    options:[
                        {
                            value: 'NOREPLACEMENT',
                            label: this.$t('erp.aftersales.noreplacement',{defaultValue:'未补发'})
                        },
                        {
                            value: 'REPLACEMENTING',
                            label: this.$t('erp.aftersales.replacementing',{defaultValue:'待补发'})
                        },
                        {
                            value: 'REPLACEMENTED',
                            label: this.$t('erp.aftersales.replacemented',{defaultValue:'已补发'})
                        },
                        {
                            value: 'NULLIFY',
                            label: this.$t('erp.aftersales.nullify',{defaultValue:'已作废'})
                        },
                    ],
                    style: "width:180px",
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('fbb.adjustment.created_name',{defaultValue:'创建人'}),
                    tag: 'vInput',
                    key: 'CN_createdName',
                    style: "width:180px",
                },
                {
                    label: this.$t('',{defaultValue:'erpsku'}),
                    tag: 'vInput',
                    key: 'EQ_orderServiceItemsEntityList.erpSku',
                    style: "width:180px",
                },
                {
                    label: this.$t('e',{defaultValue:'sellersku'}),
                    tag: 'vInput',
                    key: 'EQ_orderServiceItemsEntityList.sellerSku',
                    style: "width:180px",
                }
            ]
        },
        columns() {
            return  [
            {
                show:false,
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: this.$t('global.common.operation',{defaultValue:'操作'}),
                width: !(this.formData.search['all']==null) ? 0 : 70,
                render:this.getOperateNodes,
            }, {
                title: this.$t('erp.aftersales.orderServiceNo',{defaultValue:'售后单号'}),
                sortable: true,
                render:(h,{row})=>{
                    return <div>
                        <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.orderServiceNo}</a>
                        <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                }
            },
            {
                title: this.$t('global.common.status',{defaultValue:'状态'}),
                width: !(this.formData.search['all']==null) ? 0 : 90,
                render(h,{row}){
                    switch (row.orderStatus) {
						case 'ARRANGED': return <vButton class="b2cspan-warning span-padding">{this.$t('global.upload.before_archive',{defaultValue:'已归档'})}</vButton>; break;
						case 'FINISHED': return <vButton class="b2cspan-light-content span-padding">{this.$t('global.upload.complete',{defaultValue:'已完成'})}</vButton>; break;
						case 'ESTABLISH': return <vButton class="b2cspan-success span-padding">{this.$t('fbb.costmanage.created',{defaultValue:'已创建'})}</vButton>; break;
						case 'INPROCESS': return <vButton class="b2cspan-info span-padding">{this.$t('bi.work.task_status_processing',{defaultValue:'处理中'})}</vButton>; break;
						case 'NULLIFY': return <vButton class="b2cspan-error span-padding">{this.$t('erp.aftersales.nullify',{defaultValue:'已作废'})}</vButton>; break;
					}
                }
            },
            {
                title: this.formData.search['NE_replacementId']=='0' || this.formData.search['all']==null ? this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'})+'/'+this.$t('erp.aftersales.replaceorder',{defaultValue:'补发单号'}) : this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
                sortable: true,
                render:(h,{row})=>{
                    let aa;
                    if(row.orderServiceReplacementItemsEntity==null){
                        aa = '--'
                    }else{
                        aa = row.orderServiceReplacementItemsEntity.replacementOrderNo
                    }
                    return <div>
                        <div v-show={row.orderId == 0}>{row.orderNo}</div>
                        <div v-show={row.orderId != 0}><a onClick={this.handleOperates.bind(this, row.orderId, 'b2cquery')}>{row.orderNo}</a></div>
                        <div v-show={this.formData.search['NE_replacementId']=='0' || this.formData.search['all']==null}>
                            {aa}
                        </div>
                    </div>
                }
            },
            {
                title: this.$t('erp.b2c.channel_account',{defaultValue:'渠道账号'})+'/'+this.$t('global.common.project',{defaultValue:'项目'}),
                // key: 'sourceChannel',
                render:(h,{row})=>{
                    const {lineId}=row;
                    const {label}=this.getNewProductList.find(function(item){
                        return item.value==lineId
                    })||{};
                    return <div>
                        <div>{row.sourceChannel || '--'}</div>
                        <div class="b2ccolor-success">{label || '--'}</div>
                    </div>;
                }
            },
            // ||
            {
                title: this.$t('erp.aftersales.allstatus',{defaultValue:'退款/退货/补发状态'}),
                width: this.formData.search['all']==null ? 180 : 0,
                render:(h,{row})=>{
                    let refund,goods,replacement;
                    if(row.orderServiceRefundItemsEntity==null){
                        refund = '--'
                    }else{
                        switch(row.orderServiceRefundItemsEntity.refundStatus){
                            case 'NOREFUND': refund = this.$t('erp.aftersales.norefund',{defaultValue:'未退款'}); break;
                            case 'REFUNDED': refund = this.$t('erp.aftersales.refunded',{defaultValue:'已退款'}); break;
                            case 'NULLIFY': refund = this.$t('erp.aftersales.nullify',{defaultValue:'已作废'}); break;
                        }
                    }
                    if(row.orderServiceReturnItemsEntity==null){
                        goods = '--'
                    }else{
                        switch(row.orderServiceReturnItemsEntity.returnStatus){
                            case 'NORETURN': goods = this.$t('erp.aftersales.noreturn',{defaultValue:'未退货'}); break;
                            case 'RETURNED': goods = this.$t('erp.aftersales.returned',{defaultValue:'已退货'}) ; break;
                            case 'RETURNING': goods = this.$t('erp.aftersales.returning',{defaultValue:'已接收'}) ; break;
                            case 'NULLIFY': goods = this.$t('erp.aftersales.nullify',{defaultValue:'已作废'}) ; break;
                        }
                    }
                    if(row.orderServiceReplacementItemsEntity==null){
                        replacement = '--'
                    }else{
                        switch(row.orderServiceReplacementItemsEntity.replacementStatus){
                            case 'NOREPLACEMENT': replacement = this.$t('erp.aftersales.noreplacement',{defaultValue:'未补发'}); break;
                            case 'REPLACEMENTING': replacement = this.$t('erp.aftersales.replacementing',{defaultValue:'待补发'}); break;
                            case 'REPLACEMENTED': replacement = this.$t('erp.aftersales.replacemented',{defaultValue:'已补发'}); break;
                            case 'NULLIFY': replacement = this.$t('erp.aftersales.nullify',{defaultValue:'已作废'}); break;
                        }
                    }
                    return <div>
                        <div>{refund}</div>
                        <div>{goods}</div>
                        <div>{replacement}</div>
                    </div>
                }
            },
            {
                title: this.$t('erp.aftersales.refundStatus',{defaultValue:'退款状态'}),
                width: this.formData.search['NE_refundId']=='0' ? 120 : 0,
                render:(h,{row})=>{
                    if(row.orderServiceRefundItemsEntity==null){
                        return <div>--</div>
                    }else{
                        switch(row.orderServiceRefundItemsEntity.refundStatus){
                            case 'NOREFUND': return <div>{this.$t('erp.aftersales.norefund',{defaultValue:'未退款'})}</div>; break;
                            case 'REFUNDED': return <div>{this.$t('erp.aftersales.refunded',{defaultValue:'已退款'})}</div>; break;
                            case 'NULLIFY': return <div>{this.$t('fbb.costmanage.canceled',{defaultValue:'已作废'})}</div>; break;
                        }
                    }
                }
            },
            {
                title: this.$t('erp.aftersales.refundamount',{defaultValue:'退款金额'}),
                width: this.formData.search['NE_refundId']=='0' ? 80 : 0,
                render:(h,{row})=>{
                    if(row.orderServiceRefundItemsEntity==null){
                        return <div>--</div>
                    }else{
                        return <div>{row.orderServiceRefundItemsEntity.refundAmount}</div>
                    }

                }
            },
            {
                title: this.$t('global.common.currency',{defaultValue:'币种'}),
                width: this.formData.search['NE_refundId']=='0' ? 70 : 0,
                render:(h,{row})=>{
                    if(row.orderServiceRefundItemsEntity==null){
                        return <div>--</div>
                    }else{
                        return <div>{row.orderServiceRefundItemsEntity.currency}</div>
                    }
                }
            },
            {
                title: this.$t('erp.aftersales.goodsStatus',{defaultValue:'退货状态'}),
                width: this.formData.search['NE_returnId']=='0' ? 120 : 0,
                render:(h,{row})=>{
                    if(row.orderServiceReturnItemsEntity==null){
                        return <div>--</div>
                    }else{
                        switch(row.orderServiceReturnItemsEntity.returnStatus){
                            case 'NORETURN': return <div>{this.$t('erp.aftersales.noreturn',{defaultValue:'未退货'})}</div>; break;
                            case 'RETURNED': return <div>{this.$t('erp.aftersales.returned',{defaultValue:'已退货'})}</div>; break;
                            case 'RETURNING': return <div>{this.$t('erp.aftersales.returned',{defaultValue:'已接收'})}</div>; break;
                            case 'NULLIFY': return <div>{this.$t('fbb.costmanage.canceled',{defaultValue:'已作废'})}</div>; break;
                        }
                    }
                }
            },
            {
                title: this.$t('erp.aftersales.return_num',{defaultValue:'退货数量'}),
                width: this.formData.search['NE_returnId']=='0' ? 80 : 0,
                render:(h,{row})=>{
                    if(row.orderServiceReturnItemsEntity==null){
                        return <div>--</div>
                    }else{
                        return <div>{row.orderServiceReturnItemsEntity.returnNum}</div>
                    }

                }
            },
            {
                title: this.$t('erp.aftersales.replacementStatus',{defaultValue:'补发状态'}),
                width: this.formData.search['NE_replacementId']=='0' ? 120 : 0,
                render:(h,{row})=>{
                    if(row.orderServiceReplacementItemsEntity==null){
                        return <div>--</div>
                    }else{
                        switch(row.orderServiceReplacementItemsEntity.replacementStatus){
                            case 'NOREPLACEMENT': return <div>{this.$t('erp.aftersales.noreplacement',{defaultValue:'未补发'})}</div>; break;
                            case 'REPLACEMENTING': return <div>{this.$t('erp.aftersales.replacementing',{defaultValue:'待补发'})}</div>; break;
                            case 'REPLACEMENTED': return <div>{this.$t('erp.aftersales.replacemented',{defaultValue:'已补发'})}</div>; break;
                            case 'NULLIFY': return <div>{this.$t('fbb.costmanage.canceled',{defaultValue:'已作废'})}</div>; break;
                        }
                    }
                }
            },
            {
                title: this.$t('erp.aftersales.replacement_num',{defaultValue:'补发数量'}),
                width: this.formData.search['NE_replacementId']=='0' ? 80 : 0,
                render:(h,{row})=>{
                    if(row.orderServiceReplacementItemsEntity==null){
                        return <div>--</div>
                    }else{
                        return <div>{row.orderServiceReplacementItemsEntity.replacementNum}</div>
                    }
                }
            },


            {
                title: this.$t('fbb.adjustment.created_name',{defaultValue:'创建人'}),
                key: 'createdName',
                width:80
            },
            {
                title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                key: 'updatedAt',
                width: !(this.formData.search['all']==null) ? 0 : 150,
                sortable: true
            },
            {
                title: this.$t('erp.aftersales.refundAt',{defaultValue:'退款时间'}),
                width: this.formData.search['NE_refundId']=='0' ? 150 : 0,
                sortable: true,
                render(h,{row}){
                    if(row.orderServiceRefundItemsEntity==null){
                        return <div>--</div>
                    }else{
                        return <div>{row.orderServiceRefundItemsEntity.refundAt}</div>
                    }
                }
            },
            {
                title: this.$t('erp.aftersales.returnAt',{defaultValue:'退货时间'}),
                width: this.formData.search['NE_returnId']=='0' ? 150 : 0,
                sortable: true,
                render(h,{row}){
                    if(row.orderServiceReturnItemsEntity==null){
                        return <div>--</div>
                    }else{
                        return <div>{row.orderServiceReturnItemsEntity.returnAt}</div>
                    }
                }
            },
            {
                title: this.$t('erp.aftersales.replacementAt',{defaultValue:'补发时间'}),
                width: this.formData.search['NE_replacementId']=='0' ? 150 : 0,
                sortable: true,
                render(h,{row}){
                    if(row.orderServiceReplacementItemsEntity==null){
                        return <div>--</div>
                    }else{
                        return <div>{row.orderServiceReplacementItemsEntity.replacementAt}</div>
                    }
                }
            },
        ];
        },

    },

};
